import { parseAnalyticsProperties } from '@/shared/composables/analytics/useAnalyticsProperties';

export default function handleNativeClickEvent(evt) {
  if (!evt) return;

  const closestButton = evt.target.closest('button');
  if (!closestButton) return;
  if (closestButton.attributes['data-skip-event']) return;

  // Extract displayed text from .v-btn__content to avoid including prepend/append icon text
  const contentElement = closestButton.querySelector('.v-btn__content');
  const displayedText = contentElement
    ? (contentElement.textContent || contentElement.innerText || '').trim()
    : (closestButton.textContent || closestButton.innerText || '').trim();
  const analyticsPropertiesJson = closestButton.attributes['data-analytics-properties']?.value;

  const properties = {
    text: displayedText,
    translated_text: displayedText,
    locale: window.locale || 'en',
    organization_id: window.organization_id,
    organization_name: window.organization_name,
    window_url: window.location.href,
    window_pathname: window.location.pathname,
    window_search: window.location.search,
  };

  // Parse and merge analytics properties from data attribute
  // This may override 'text' with English text from StandardButton, but 'displayed_text' preserves what user saw
  const analyticsProps = parseAnalyticsProperties(analyticsPropertiesJson);
  if (analyticsProps) {
    Object.assign(properties, analyticsProps);
  }

  window.analytics?.track?.('Button Clicked', properties);
}
